import React from "react";
import { LinkWithMassage } from "../../../../components/layouts/LinkWithMassage";

const message = `
  You're about to send an email to us. In order to compose an email please click the button.
`;

export function Route() {
  return (
    <LinkWithMassage
      header="Message Us"
      href="mailto:info@getspeechify.com?subject=message%20us"
      message={message}
      title="compose mail"
    />
  );
}
